// Author YuJiaBei
// Date 2020-11-10 11:33:21

class SithMesPrdOperationUser {
constructor({
        id = null,
        admUserId = '',
        admUserIdName = '',
        prdPpOperationId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.admUserId = admUserId;
    this.admUserIdName = admUserIdName;
    this.prdPpOperationId = prdPpOperationId;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdOperationUser();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.projectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectMachine1',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.projectMachine1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectMachine2',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.projectMachine2',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'prdPpOperationForecastMstLocationId',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationForecastMstLocationId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationForecastMstLocationName',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationForecastMstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationStatus',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationStatus',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpHeaderOrderCode',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpHeaderOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationSeq',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationSeq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationDescription',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationDescription',
        sortable: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'prdPpOperationForecastBeginTime',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationForecastBeginTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationForecastFinishTime',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationForecastFinishTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationActualMstLocationName',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationActualMstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationWorkCenterCode',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationWorkCenterCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'admUserIdName',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.admUserIdName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpHeaderId',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpHeaderId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpHeaderOrderType',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpHeaderOrderType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpHeaderMaterialCode',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpHeaderMaterialCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpHeaderWbsCode',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpHeaderWbsCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationId',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationCtrlKey',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationCtrlKey',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationQuantity',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationQuantity',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdPpOperationWorkHour',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.prdPpOperationWorkHour',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdOperationUser.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    projectCodeFilter : "",
    projectMachine1Filter : "",
    projectMachine2Filter : "",
    forecastMstLocationIdFilter : "",
    forecastMstLocationNameFilter : "",
    prdPpStatusCodeFilter : "",
    prdPpHeaderWbsCodeFilter : "",
    prdPpHeaderOrderCodeFilter : "",
    prdPpHeaderMaterialDescriptionFilter : "",
    forecastBeginTimeRteFilter : "",
    forecastBeginTimeLteFilter : "",
    forecastFinishTimeRteFilter : "",
    forecastFinishTimeLteFilter : "",
    operationIdInFilter : "",
    prdPpStatusCodeInFilter : "",
    prdPpStatusCodeGteFilter : "",
    prdPpStatusCodeLteFilter : "",
    admUserIdFilter : "",
    admUserIdInFilter : "",
    admUserIdNameFilter : "",
    prdPpHeaderIdFilter : "",
    prdPpOperationIdFilter : "",
    prdPpOperationSeqFilter : "",
    prdPpHeaderMaterialCodeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.projectCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectMachine1Filter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.projectMachine1',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectMachine2Filter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.projectMachine2',
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'forecastMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.forecastMstLocationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"forecastMstLocationId":"id"}'
                }
        },
        {
        key: 'prdPpStatusCodeFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpStatusCode',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'sithMesPrdPpStatus'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'prdPpHeaderWbsCodeFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpHeaderWbsCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prdPpHeaderOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpHeaderOrderCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpHeader'
            ,correspondingField: 'orderCode'
            ,fieldsBindingByEntityModalSelected: '{"prdPpHeaderId":"id"}'
                }
        },
        {
        key: 'prdPpHeaderMaterialDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpHeaderMaterialDescription',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'forecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.forecastBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'forecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.forecastBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'forecastFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.forecastFinishTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'forecastFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.forecastFinishTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'admUserIdNameFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.admUserIdName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"admUserId":"id"}'
                }
        },
        {
        key: 'prdPpOperationIdFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpOperationId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'sithMesPrdPpOperation'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'prdPpOperationSeqFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpOperationSeq',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'operationSeq'
            ,fieldsBindingByEntityModalSelected: '{"prdPpOperationId":"id"}'
                }
        },
        {
        key: 'prdPpHeaderMaterialCodeFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpHeaderMaterialCode',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];
const andonUserFilterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.projectCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectMachine1Filter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.projectMachine1',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'projectMachine2Filter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.projectMachine2',
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'forecastMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.forecastMstLocationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"forecastMstLocationId":"id"}'
                }
        },
        {
        key: 'prdPpStatusCodeFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpStatusCode',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'sithMesPrdPpStatus'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'prdPpHeaderWbsCodeFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpHeaderWbsCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prdPpHeaderOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpHeaderOrderCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpHeader'
            ,correspondingField: 'orderCode'
            ,fieldsBindingByEntityModalSelected: '{"prdPpHeaderId":"id"}'
                }
        },
        {
        key: 'prdPpHeaderMaterialDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.prdPpHeaderMaterialDescription',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'forecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.forecastBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'forecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.forecastBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'forecastFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.forecastFinishTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'forecastFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdOperationUser.filter.forecastFinishTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'admUserIdName',
        label: 'label.sith.prd.sithMesPrdOperationUser.entity.admUserIdName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"admUserId":"id"}'
                }
        },
        {
        key: 'prdPpOperationId',
        label: 'label.sith.prd.sithMesPrdOperationUser.entity.prdPpOperationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdOperationUser.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdOperationUser, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs, andonUserFilterConfigs


}
